import React, { Fragment, useEffect, useRef, useState } from "react";
import * as actions from "../../../store/actions/index";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import classes from "./IdentityConfirmation.css";
import Message from "../../../components/Message/Message";
import ToggleSwitch from "../../../UI/ToggleSwitch/ToggleSwitch";
import Button from "../../../UI/Button/Button";
import Spinner from "../../../UI/Spinner/Spinner";
import Modal from "../../../UI/Modal/Modal";
import Input from "../../../UI/Input/Input";
import {
  IC_OTP_GENERATION_DESC,
  IC_DBIC_DESC,
  SESSION_SUPERVISORUSER,
  SESSION_SUPERUSER,
  IC_2STEP_DESC,
  SESSION_TIER1USER,
  ID_TYPE_NEW
} from "../../../shared/Constants";
import { isAccountDisabled, checkValidity, getOtpVerifiedNumber, EMAIL_MATCHER_REGEX } from "../../../shared/utility";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import OTPInput from "react-otp-input";
import moment from "moment";

const identityConfirmation = (props) => {
  const RESEND_DBIC_LINK_COOLDOWN_MS = 2 * 60 * 1000;
  const [showDeleteModal, setShowDeleteModal] = useState(null);
  const [showTwoStepModal, setShowTwoStepModal] = useState(false);
  const [showSkipModal, setShowSkipModal] = useState(false);
  const [showResendLinkModal, setShowResendLinkModal] = useState(false);
  const [showDbicInfo, setShowDbicInfo] = useState(false);
  const [skipState, setSkipState] = useState(1);
  const [isPoaSelected, setIsPoaSelected] = useState(false);
  const [carouselState, setCarouselState] = useState(0);
  const [formError, setFormError] = useState("");
  const [dbicFormError, setDbicFormError] = useState("");
  const [countryCode, setCountryCode] = useState(
    props.essoData?.phone?.countryCode ? props.essoData.phone.countryCode : "",
  );
  const [email, setEmail] = useState(
    props.essoData?.email?.value ? props.essoData.email.value : "",
  );
  const [phoneNumber, setPhoneNumber] = useState(
    props.essoData?.phone?.number ? props.essoData.phone.number : "",
  );
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dob, setDob] = useState("");
  const [originalDetails, setOriginalDetails] = useState({});
  const [dbicPollResetSignal, setDbicPollResetSignal] = useState(0);
  const [dbicPollCount, setDbicPollCount] = useState(0);
  const [twoStepMessage, setTwoStepMessage] = useState("");
  const [otp, setOtp] = useState("");
  const [linkMethod, setLinkMethod] = useState("SMS");
  const [isResendDbicLinkCoolingDown, setIsResendDbicLinkCoolingDown] = useState(false);
  let resetSpinnerTimer = null;
  const pollTime = 5 // 5 minutes
  const carouselRef = useRef();
  const dbicPollTimeoutRef = useRef(null);
  const dbicPollDeadlineRef = useRef(null);
  const resendDbicLinkCooldownTimeoutRef = useRef(null);
  const suppressDbicAutoAdvanceRef = useRef(false);
  const isDbicDoneBefore = props.isDbicDoneBefore;
  const dbicState = props.dbicState;
  const dbicDocVerificationStatus = props.dbicData?.docVerificationStatus;
  const dbicRequestId = props.dbicData?.requestId;
  const dbicTransactionId = props.dbicData?.idVerseTransactionId;
  const isSuperVisorOrSuperUser = [
    SESSION_SUPERVISORUSER,
    SESSION_SUPERUSER,
  ].includes(props.user?.userType);
  const enableStepTwoTierOne = props.user?.features?.enableStepTwoTierOne && props.user?.userType === SESSION_TIER1USER;
  const isSuperUser = [
    SESSION_SUPERUSER,
  ].includes(props.user?.userType);

  const isUserLockedOnVerify = props.verifyOtpMessage?.type === "Error" && props.verifyOtpMessage?.info?.message?.includes("locked");
  const isUserDisabledOnVerify = props.verifyOtpMessage?.type === "Error" && props.verifyOtpMessage?.info?.message?.includes("disabled");

  const getIdentityConfirmationFlow = () => {
    if (skipState === 1) {
      return "Phone-based";
    } else if (skipState === 2) {
      return "Document-based";
    } else if (skipState === 3) {
      return "Two-step";
    }
  }

  const identityConfirmationFlow = getIdentityConfirmationFlow();
  const isOtpVerified =
    props.isOTPVerified || props.isNullHSID || props.isHeadlessUser;

  const otpVerificaitonNotifier = isOtpVerified ? null : (
    <div className={classes.OTPMessageDiv}>
      <Message msgType="Error" info={{ message: "" }} />
    </div>
  );

  const shouldHideTwoStepAttestation = [
    ID_TYPE_NEW.HSID_BASE,
    ID_TYPE_NEW.HSID_PARTIAL_REGISTRATION
  ].includes(props.member?.idType)

  const generateOtprNotifier =
    props.generateOtpMessage || formError?.type ? (
      <div className={classes.OTPMessageDiv}>
        <Message
          new
          msgType={props.generateOtpMessage?.type || formError?.type}
          info={props.generateOtpMessage?.info || formError?.info}
        />
      </div>
    ) : null;

  const dbicFormNotifier =
    dbicFormError?.type ? (
      <div className={classes.OTPMessageDiv}>
        <Message
          new
          msgType={dbicFormError?.type}
          info={dbicFormError?.info}
        />
      </div>
    ) : null;

  const tempGenerateOtpNotifier =
    props.tempGenerateOtpMessage ? (
      <div className={classes.OTPMessageDiv}>
        <Message
          new
          timer
          timeCallback={props.resetTempGenerateOtpMessage}
          msgType={props.tempGenerateOtpMessage?.type}
          info={props.tempGenerateOtpMessage?.info}
        />
      </div>
    ) : null;

  const sendDbicLinkMessageNotifier =
    props.sendDbicLinkMessage ? (
      <div className={classes.OTPMessageDiv}>
        <Message
          new
          timer
          timeCallback={props.resetSendDbicLinkMessage}
          msgType={props.sendDbicLinkMessage?.type}
          info={props.sendDbicLinkMessage?.info}
        />
      </div>
    ) : null;

  const expiredLinkMessageNotifier =
    props.expiredLinkMessage ? (
      <div className={classes.OTPMessageDiv}>
        <Message
          new
          timer
          timeCallback={props.resetExpiredLinkMessage}
          msgType={props.expiredLinkMessage?.type}
          info={props.expiredLinkMessage?.info}
        />
      </div>
    ) : null;

  const reSendDbicLinkMessageNotifier =
    props.reSendDbicLinkMessage ? (
      <div className={classes.OTPMessageDiv}>
        <Message
          new
          timer
          timeCallback={props.resetReSendDbicLinkMessage}
          msgType={props.reSendDbicLinkMessage?.type}
          info={props.reSendDbicLinkMessage?.info}
        />
      </div>
    ) : null;

  const verifyOtpNotifier = props.verifyOtpMessage ? (
    <div className={classes.OTPMessageDiv}>
      <Message
        new
        msgType={props.verifyOtpMessage.type}
        info={props.verifyOtpMessage.info}
      />
    </div>
  ) : null;

  const twoStepNotifier = twoStepMessage ? (
    <div className={classes.OTPMessageDiv}>
      <Message new msgType={twoStepMessage?.type} info={twoStepMessage?.info} />
    </div>
  ) : null;

  const verifyOtpTmxNotifier = props.verifyOtpTmxMessage && props.verifyOtpTmxMessage?.info?.message ? (
    <div className={classes.OTPMessageDiv}>
      <Message
        new
        msgType={props.verifyOtpTmxMessage.type}
        info={props.verifyOtpTmxMessage.info}
      />
    </div>
  ) : null;

  useEffect(() => {
    const { number } = getOtpVerifiedNumber();
    if (!number && (phoneNumber === props.essoData?.phone?.number && countryCode === props.essoData?.phone?.countryCode)) {
      if (props.essoData?.phone?.countryCode) {
        setCountryCode(props.essoData.phone.countryCode);
      }
      if (props.essoData?.phone?.number) {
        setPhoneNumber(props.essoData.phone.number);
      }
    }
  }, [props.essoData]);

  useEffect(() => {
    return () => {
      if (resendDbicLinkCooldownTimeoutRef.current) {
        clearTimeout(resendDbicLinkCooldownTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (suppressDbicAutoAdvanceRef.current) {
      return;
    }

    if (props.generateOtpMessage?.type === "Success") {
      setCarouselState(1);
    }
    if (
      (props.verifyOtpMessage?.type === "Success" &&
        props.verifyOtpTmxMessage?.type === "Success") ||
      dbicState === "success"
    ) {
      setCarouselState(-1);
      return;
    }
    if (
      props.verifyOtpMessage?.type === "Success" &&
      props.verifyOtpTmxMessage?.type !== "Success" &&
      carouselState !== -1 &&
      !suppressDbicAutoAdvanceRef.current
    ) {
      carouselRef.current.goToSlide(1);
      setCarouselState(2);
    }
  }, [
    props.generateOtpMessage,
    props.verifyOtpMessage,
    props.verifyOtpTmxMessage,
    dbicState,
  ]);

  useEffect(() => {
    if (
      props.verifyOtpMessage?.type === "Success" &&
      props.verifyOtpTmxMessage?.type !== "Success" &&
      carouselState !== -1
    ) {
      props.getDbicDetails({
        uuid: props.essoData.uuid,
        phone: phoneNumber ?? props.essoData.phone?.number,
        countryCode: countryCode ?? props.essoData.phone?.countryCode,
        firstName: isPoaSelected ? firstName : props.essoData.firstName,
        lastName: isPoaSelected ? lastName : props.essoData.lastName,
        dateOfBirth: isPoaSelected ? dob : props.essoData.dob,
        email: email ?? props.essoData.email?.value ?? '',
      }, {
        uuid: props.essoData.uuid,
        userName: props.essoData.userName,
        idType: props.essoData.idType,
        phoneno: props.essoData.phone?.number,
        countryCode: props.essoData.phone?.countryCode,
      }, props.reuseFlow,
        isPoaSelected ? {
          firstName, lastName, dob
        } : null, identityConfirmationFlow);
    }
  }, [props.verifyOtpMessage,
  props.verifyOtpTmxMessage,])

  const clearDbicPolling = () => {
    if (dbicPollTimeoutRef.current) {
      clearTimeout(dbicPollTimeoutRef.current);
      dbicPollTimeoutRef.current = null;
    }
  };

  const resetDbicPollingWindow = () => {
    clearDbicPolling();
    dbicPollDeadlineRef.current = null;
    setDbicPollResetSignal((currentSignal) => currentSignal + 1);
  };

  const getDbicPollPayload = () => ({
    uuid: props.essoData?.uuid,
    phone: phoneNumber ?? props.essoData?.phone?.number,
    countryCode: countryCode ?? props.essoData?.phone?.countryCode,
    firstName: isPoaSelected ? firstName : props.essoData.firstName,
    lastName: isPoaSelected ? lastName : props.essoData.lastName,
    dateOfBirth: isPoaSelected ? dob : props.essoData.dob,
    requestId: dbicRequestId,
    idVerseTransactionId: dbicTransactionId,
    email: email ?? props.essoData.email?.value ?? '',
  });

  useEffect(() => {
    return () => {
      clearDbicPolling();
      handleStartOver();
    };
  }, []);

  useEffect(() => {
    if (dbicState !== "pending" || !props.essoData?.uuid) {
      clearDbicPolling();
      dbicPollDeadlineRef.current = null;
      setDbicPollCount(0);
      return;
    }

    if (!dbicPollDeadlineRef.current) {
      dbicPollDeadlineRef.current = Date.now() + pollTime * 60 * 1000;
    }

    let isActive = true;

    const scheduleNextPoll = () => {
      clearDbicPolling();

      if (
        !isActive ||
        Date.now() >= dbicPollDeadlineRef.current ||
        dbicDocVerificationStatus
      ) {
        dbicPollDeadlineRef.current = null;
        if (!dbicDocVerificationStatus) {
          props.dbicPollingFailure(true);
        }
        return;
      }

      dbicPollTimeoutRef.current = setTimeout(() => {
        setDbicPollCount((currentCount) => currentCount + 1);
        Promise.resolve(
          props.pollDbic(getDbicPollPayload(), {
            uuid: props.essoData.uuid,
            userName: props.essoData.userName,
            idType: props.essoData.idType,
            phoneno: props.essoData.phone?.number,
            countryCode: props.essoData.phone?.countryCode,
          }, props.reuseFlow,
            isPoaSelected ? {
              firstName, lastName, dob
            } : null,
            identityConfirmationFlow
          ),
        )
          .then((data) => {
            if (data?.payload?.docVerificationStatus) {
              isActive = false;
              clearDbicPolling();
              dbicPollDeadlineRef.current = null;
            }
          })
          .finally(() => {
            dbicPollTimeoutRef.current = null;

            if (!isActive) {
              return;
            }

            scheduleNextPoll();
          });
      }, 5000);
    };
    if (isActive) {
      const userData = {
        uuid: props.essoData.uuid,
        phoneno: phoneNumber ?? props.essoData?.phone?.number,
        username: props.essoData.userName,
        countryCode: countryCode ?? props.essoData?.phone?.countryCode,
        event: "DOCUMENT_BASED_ID_CONFIRMATION_POLLING",
        eventStatus: "SUCCESS",
        newData: {
          RequestId: dbicRequestId,
          IdVerseTransactionId: dbicTransactionId,
          "ReuseFlow": props.reuseFlow ? "Yes" : "No",
          ...(isPoaSelected ? {
            Firstname: firstName,
            Lastname: lastName,
            DOB: dob
          } : {}),
          NewUI: "Yes",
          "IdentityConfirmationFlow": identityConfirmationFlow,
        }
      }
      props.pushtoActivityLog(userData, {}, identityConfirmationFlow)
      scheduleNextPoll();
    }

    return () => {
      isActive = false;
      clearDbicPolling();
    };
  }, [
    dbicState,
    props.essoData,
    phoneNumber,
    countryCode,
    dbicDocVerificationStatus,
    dbicRequestId,
    dbicTransactionId,
    dbicPollResetSignal,
  ]);

  useEffect(() => {
    if (props.reSendDbicLinkMessage?.type === "Success") {
      resetDbicPollingWindow();
      if (resetSpinnerTimer) {
        resetSpinnerTimer();
      }
      setIsResendDbicLinkCoolingDown(true);
      if (resendDbicLinkCooldownTimeoutRef.current) {
        clearTimeout(resendDbicLinkCooldownTimeoutRef.current);
      }
      resendDbicLinkCooldownTimeoutRef.current = setTimeout(() => {
        setIsResendDbicLinkCoolingDown(false);
        resendDbicLinkCooldownTimeoutRef.current = null;
      }, RESEND_DBIC_LINK_COOLDOWN_MS);
    }
  }, [props.reSendDbicLinkMessage])

  const handleWhatIsDbic = () => {
    setShowDbicInfo(true);
  };

  const handleSendOtp = (event, otpType, origin) => {
    if (props.disableTab === "-1") {
      return;
    }
    let formData = {
      uuid: props.healthSafeId ? props.healthSafeId : props.essoData.uuid,
      phoneNo:
        phoneNumber && phoneNumber !== props.essoData.phone.number
          ? phoneNumber
          : props.essoData.phone.number,
      phoneType: props.essoData.phone.label === "MOBILE" ? "true" : "false",
      userId: props.essoData.userName,
      countryCode:
        countryCode && countryCode !== props.essoData.phone?.countryCode
          ? countryCode
          : props.essoData.phone?.countryCode,
      essoNumber: props.essoData.phone?.number,
      essoCountryCode: props.essoData.phone?.countryCode,
      otpMethod: otpType === "Phone" ? "sms" : "call",
    };
    props.generateSmsOtpToken(formData, otpType, origin, identityConfirmationFlow);
  };

  const handleVerifyOtp = () => {
    if (props.genTokenResponse && props.genTokenResponse.sessionid) {
      let formData = {
        sessionid: props.genTokenResponse?.sessionid,
        transactionid: props.genTokenResponse?.transactionid,
        username: props.genTokenResponse?.uuid,
        phoneno: phoneNumber ?? props.essoData.phone?.number,
        homePhone: props.essoData.phone?.label === "MOBILE" ? true : false,
        token: otp,
        phoneProviderSessionId: props.genTokenResponse?.phoneProviderSessionId,
        userId: props.essoData.userName,
        countryCode: countryCode ?? props.essoData.phone?.countryCode,
        essoNumber: props.essoData.phone?.number,
        essoCountryCode: props.essoData.phone?.countryCode,
        ...(isPoaSelected ? {
          firstName,
          lastName,
        } : {})
      };
      props.verifySmsOtpToken(formData, {
        uuid: props.essoData.uuid,
        idType: props.essoData.idType,
        phoneno: props.essoData.phone?.number,
        countryCode: props.essoData.phone?.countryCode,
      }, identityConfirmationFlow);
    } else {
      props.setOtpDisplayMessage({
        type: "Error",
        info: { message: "Wrong Code" },
      });
    }
  };

  const handleSendDbicLink = () => {
    let formData = {
      phone: phoneNumber ?? props.essoData.phone?.number,
      userName: props.essoData.userName,
      firstName: isPoaSelected ? firstName : props.essoData.firstName,
      lastName: isPoaSelected ? lastName : props.essoData.lastName,
      dateOfBirth: isPoaSelected ? dob : props.essoData.dob,
      uuid: props.essoData.uuid,
      countryCode: countryCode ?? props.essoData.phone?.countryCode,
      email: email || props.essoData.email?.value,
      skipDbicStore: skipState === 2,
      deliveryChannel: linkMethod,
    };
    props.sendDbicLink(formData, identityConfirmationFlow);
  };

  const handlereSendDbicLink = () => {
    if (isResendDbicLinkCoolingDown) {
      return;
    }

    let formData = {
      phone: phoneNumber ?? props.essoData.phone?.number,
      uuid: props.essoData.uuid,
      resendMethod: linkMethod,
      link: props.dbicData?.shortUrl || props.dbicData?.link,
      countryCode: countryCode ?? props.essoData.phone?.countryCode,
      email: email ?? props.essoData.email?.value,
      username: props.essoData.userName,
    };
    props.reSendDbicLink(formData, identityConfirmationFlow);
  };

  const handleStartOver = () => {
    suppressDbicAutoAdvanceRef.current = false;
    props.resetOtpGeneratedMessage();
    props.resetExpiredLinkMessage();
    props.resetReSendDbicLinkMessage();
    props.resetSendDbicLinkMessage();
    carouselRef.current.goToSlide(0);
    setOtp("");
    setCarouselState(0);
    setTwoStepMessage("");
    setSkipState(1);
    setDbicFormError("");
    setCountryCode(props.essoData.phone?.countryCode || "")
    setPhoneNumber(props.essoData.phone?.number || "")
    setEmail(props.essoData?.email?.value || "")
    setLinkMethod("SMS")
  };

  const handleTryAgain = () => {
    props.getIdverseResults({
      uuid: props.essoData.uuid,
      phone: phoneNumber ?? props.essoData.phone?.number,
      countryCode: countryCode ?? props.essoData.phone?.countryCode,
      firstName: isPoaSelected ? firstName : props.essoData.firstName,
      lastName: isPoaSelected ? lastName : props.essoData.lastName,
      dateOfBirth: isPoaSelected ? dob : props.essoData.dob,
      email: email ?? props.essoData.email?.value ?? '',
      requestId: dbicRequestId,
      idVerseTransactionId: dbicTransactionId,
      username: props.essoData.userName,
    }, {
      uuid: props.essoData.uuid,
      userName: props.essoData.userName,
      idType: props.essoData.idType,
      phoneno: props.essoData.phone?.number,
      countryCode: props.essoData.phone?.countryCode,
    }, props.reuseFlow,
      isPoaSelected ? {
        firstName, lastName, dob
      } : null, identityConfirmationFlow);
  }

  const handle2StepRedirect = () => {
    suppressDbicAutoAdvanceRef.current = true;
    if (dbicState === "pending") {
      props.resetDbicStatus();
    }
    carouselRef.current.goToSlide(2);
    setCarouselState(3);
    if (skipState !== 1) {
      setCountryCode(props.essoData.phone?.countryCode || "")
      setPhoneNumber(props.essoData.phone?.number || "")
    }
    setEmail(props.essoData?.email?.value || "")
    setLinkMethod("SMS")
    setDbicFormError("");
  };

  const handleAttest = (flag) => {
    const data = {
      uuid: props.essoData.uuid,
      phoneno: phoneNumber ?? props.essoData.phone?.number,
      username: props.essoData.userName,
      countryCode: countryCode ?? props.essoData.phone?.countryCode,
      event: "TWO_STEP_ATTESTATION",
      eventStatus: flag ? "SUCCESS" : "FAILURE",
      newData: {
        NewUI: "Yes",
        "IdentityConfirmationFlow": identityConfirmationFlow,
      }
    };
    setCarouselState(-1);
    setTwoStepMessage({
      type: flag ? "Success" : "Error",
      info: {
        message: flag
          ? "Caller Identity verified successfully"
          : "Caller Identity could not be verified",
      },
    });
    props.initiateAttest(data, props.essoData, props.user?.userType, identityConfirmationFlow);
  };

  const inputChangeHandler = (id, value, validation) => {
    handleValidation(id, value, validation);
    if (id === "countryCode") {
      setCountryCode(value);
    } else if (id === "phone") {
      setPhoneNumber(value);
    } else if (id === "firstName") {
      setFirstName(value);
    } else if (id === "lastName") {
      setLastName(value);
    } else if (id === "dob") {
      setDob(value);
    }
  };

  const handleValidation = (id, value, validationConfig) => {
    if (validationConfig) {
      const validation = checkValidity(value, validationConfig);
      if (validation?.message) {
        return setFormError({
          type: "Error",
          info: {
            message: validation.message
          },
        });
      }
    }
    if (id === "countryCode") {
      if (value.length === 0) {
        return setFormError({
          type: "Error",
          info: {
            message: "Min 1 digit required for country code",
          },
        });
      }
      if (phoneNumber.length < 7 && phoneNumber.length >= 0) {
        return setFormError({
          type: "Error",
          info: {
            message: "Min 7 digits required for phone number",
          },
        });
      }
    } else if (id === "phone") {
      if (value.length < 7 && value.length >= 0) {
        return setFormError({
          type: "Error",
          info: {
            message: "Min 7 digits required for phone number",
          },
        });
      }
      if (countryCode.length === 0) {
        return setFormError({
          type: "Error",
          info: {
            message: "Min 1 digit required for country code",
          },
        });
      }
    }
    setFormError("");
  };

  const dbicInputChangeHandler = (id, value, validationConfig) => {
    handleDbicValidation(id, value, validationConfig);
    if (id === "countryCode") {
      setCountryCode(value);
    } else if (id === "phone") {
      setPhoneNumber(value);
    } else if (id === "email") {
      setEmail(value);
    }
  };

  const handleDbicValidation = (id, value, validationConfig) => {
    if (linkMethod === "SMS") {
      if (id === "countryCode") {
        if (value.length === 0) {
          return setDbicFormError({
            type: "Error",
            info: {
              message: "Min 1 digit required for country code",
            },
          });
        }
        if (phoneNumber.length < 7 && phoneNumber.length >= 0) {
          return setDbicFormError({
            type: "Error",
            info: {
              message: "Min 7 digits required for phone number",
            },
          });
        }
      } else if (id === "phone") {
        if (value.length < 7 && value.length >= 0) {
          return setDbicFormError({
            type: "Error",
            info: {
              message: "Min 7 digits required for phone number",
            },
          });
        }
        if (countryCode.length === 0) {
          return setDbicFormError({
            type: "Error",
            info: {
              message: "Min 1 digit required for country code",
            },
          });
        }
      }
    } else if (linkMethod === "EMAIL") {
      if (validationConfig) {
        const validation = checkValidity(value, validationConfig);
        if (validation?.message) {
          return setDbicFormError({
            type: "Error",
            info: {
              message: validation.message
            },
          });
        }
      }
    }
    setDbicFormError("");
  };

  const renderOptGenerationCard = () => {
    return (
      <div
        className={`${classes.icGenerateOtpWrapper} ${carouselState === 0 ? classes.icGenerateOtpWrapperActive : ""}`}
      >
        {carouselState !== 0 && <div className={classes.icOverlay}></div>}
        <h4 className={classes.CardEligibilityTitle}>{"Generate OTP"}</h4>
        {generateOtprNotifier}
        <div>{IC_OTP_GENERATION_DESC}</div>
        {isSuperVisorOrSuperUser && <div className={classes.icPoaContainer}>
          <div className={classes.icPoaWrapper}>
            <div className={classes.icPoaTextWrapper}>
              <div className={classes.poaText}>
                Verify on behalf (POA/AOR)
              </div>
              <a data-tip data-for="poaDetails">
                <i className="fa fa-info-circle" style={{ fontSize: "16px", color: "#0C8CA2", marginLeft: '10px' }} />
              </a>
              <ReactTooltip id="poaDetails" multiline className={classes.icTooltip}>
                <span>AORs cannot request account changes.<br />
                  POAs can request account changes.<br />
                  Escalate eligible POA cases to L1.5 for updates.</span>
              </ReactTooltip>
            </div>
            <Input
              elementType="checkbox"
              id="selectPoa"
              label=""
              checked={isPoaSelected}
              changed={() => {
                if (isPoaSelected) {
                  setFormError("");
                  setFirstName("");
                  setLastName("");
                  setDob("");
                }
                setIsPoaSelected(!isPoaSelected)

              }}
              inputType="icCheckbox"
            />
          </div>
          {isPoaSelected &&
            <>
              <Input
                key={"firstName"}
                elementType="input"
                elementConfig={{
                  type: 'text',
                  id: 'firstName',
                  placeholder: 'Enter the value',
                  maxLength: 41
                }}
                value={firstName}
                invalid={false}
                touched={false}
                disabled={false}
                label={"First name"}
                changed={(event) => {
                  if (carouselState !== 0) {
                    return;
                  }
                  inputChangeHandler("firstName", event.target.value, {
                    required: false,
                    minlength: 2,
                    maxlength: 40,
                    specialchar: ['<', '"', '+', ':', ';', '=', '\\', '*', '&', '(', ')', '#', ',']
                  });
                }}
                inputType={"icPoaInput"}
                labelClass={classes.icLabelClass}
                extendedInputClasses={classes.icExtendedInput}
                tabIndex={props.disableTab != undefined ? props.disableTab : 0}
              />
              <Input
                key={"lastName"}
                elementType="input"
                elementConfig={{
                  type: 'text',
                  id: 'lastName',
                  placeholder: 'Enter the value',
                  maxLength: 41
                }}
                value={lastName}
                invalid={false}
                touched={false}
                disabled={false}
                label={"Last name"}
                changed={(event) => {
                  if (carouselState !== 0) {
                    return;
                  }
                  inputChangeHandler("lastName", event.target.value, {
                    required: false,
                    minlength: 2,
                    maxlength: 40,
                    specialchar: ['<', '"', '+', ':', ';', '=', '\\', '*', '&', '(', ')', '#', ',']
                  });
                }}
                inputType={"icPoaInput"}
                labelClass={classes.icLabelClass}
                extendedInputClasses={classes.icExtendedInput}
                tabIndex={props.disableTab != undefined ? props.disableTab : 0}
              />
              <Input
                key={"dob"}
                elementType="input"
                elementConfig={{
                  type: 'date',
                  id: 'dob',
                  placeholder: 'mm/dd/yyyy',
                  min: '1900-01-01'
                }}
                value={dob}
                invalid={false}
                touched={false}
                disabled={false}
                label={"Date of birth"}
                changed={(event) => {
                  if (carouselState !== 0) {
                    return;
                  }
                  inputChangeHandler("dob", event.target.value, {
                    required: true,
                    restrictFuture: true,
                  });
                }}
                inputType={"icPoaInput"}
                labelClass={classes.icLabelClass}
                extendedInputClasses={classes.icExtendedInput}
                tabIndex={props.disableTab != undefined ? props.disableTab : 0}
              />
            </>}
        </div>}
        <label className={classes.icPhoneInputLabel}>Phone Number</label>
        <div className={classes.icPhoneInputWrapper}>
          <Input
            key={"inputPhoneCode"}
            elementType="inputPhoneCodeNew"
            elementConfig={{
              type: "text",
              id: "countryCode",
              minLength: 1,
              maxLength: 3,
              pattern: "[0-9]{1,3}",
              title: "Country Code can only contain numbers",
              // wrapperStyles: {zIndex: "-1"},
            }}
            value={countryCode}
            invalid={false}
            shouldValidate={{
              required: false,
              minlength: 1,
              maxlength: 3,
            }}
            touched={false}
            disabled={false}
            label={""}
            changed={(event) => {
              if (carouselState !== 0) {
                return;
              }
              if (
                event.target.value.length > 0 &&
                !/^\d+$/.test(event.target.value)
              ) {
                return;
              }
              inputChangeHandler("countryCode", event.target.value);
            }}
            inputType={"icPhoneCode"}
            extendedInputClasses={classes.icExtendedInput}
            tabIndex={props.disableTab != undefined ? props.disableTab : 0}
          />
          <Input
            key={"phoneNumber"}
            elementType="input"
            elementConfig={{
              type: "text",
              id: "phone",
              minLength: 7,
              maxLength: 15,
              pattern: "[0-9]{1,15}",
              title: "Phone Numbers can only contain numbers",
            }}
            value={phoneNumber}
            invalid={false}
            shouldValidate={{
              required: false,
              minlength: 7,
              maxlength: 15,
            }}
            touched={false}
            disabled={false}
            label={""}
            changed={(event) => {
              if (carouselState !== 0) {
                return;
              }
              if (
                event.target.value.length > 0 &&
                !/^\d+$/.test(event.target.value)
              ) {
                return;
              }
              inputChangeHandler("phone", event.target.value);
            }}
            inputType={"icPhoneInput"}
            extendedInputClasses={classes.icExtendedInput}
            tabIndex={props.disableTab != undefined ? props.disableTab : 0}
          />
        </div>
        <Button
          id="generateOtp"
          btnType="IcGenerateOTP"
          clicked={(event) => {
            if (carouselState !== 0) {
              return;
            }
            handleSendOtp(event, "Phone");
          }}
          disabled={
            formError ||
            carouselState !== 0 ||
            (isPoaSelected && (!firstName || !lastName || !dob)) ||
            !(props.essoData.phone?.number || phoneNumber) ||
            !(props.essoData.phone?.countryCode || countryCode) ||
            (props.user?.userType === SESSION_TIER1USER &&
              isAccountDisabled(props.essoData))
          }
        >
          Send code by SMS
        </Button>
        <Button
          id="generateOtp"
          btnType="IcGenerateOTPCall"
          clicked={(event) => {
            if (carouselState !== 0) {
              return;
            }
            handleSendOtp(event, "Call");
          }}
          disabled={
            formError ||
            carouselState !== 0 ||
            (isPoaSelected && (!firstName || !lastName || !dob)) ||
            !(props.essoData.phone?.number || phoneNumber) ||
            !(props.essoData.phone?.countryCode || countryCode) ||
            (props.user?.userType === SESSION_TIER1USER &&
              isAccountDisabled(props.essoData))
          }
        >
          Send code by phone call
        </Button>
      </div>
    );
  };

  const renderVerificationCard = () => {
    return (
      <div
        className={`${classes.icGenerateOtpWrapper} ${carouselState === 1 ? classes.icGenerateOtpWrapperActive : ""}`}
      >
        {carouselState !== 1 && <div className={classes.icOverlay}></div>}
        <h4 className={classes.CardEligibilityTitle}>
          {"Enter verification code"}
        </h4>
        {tempGenerateOtpNotifier}
        {(!isUserLockedOnVerify && !isUserDisabledOnVerify) && verifyOtpNotifier}
        {verifyOtpTmxNotifier}
        {(!isUserLockedOnVerify && !isUserDisabledOnVerify) ? <>
          <div>
            We sent a 6-digit code to <b>{phoneNumber}</b>. It may take a minute
            or two to receive the SMS.
          </div>
          <label className={classes.icPhoneInputLabel}>
            Enter verification code
          </label>
          <div className={classes.icPhoneInputWrapper}>
            <OTPInput
              value={otp}
              onChange={(val) => {
                if (carouselState !== 1) {
                  return;
                }
                if (!/^\d+$/.test(val)) {
                  return;
                }
                setOtp(val);
              }}
              numInputs={6}
              renderSeparator={null}
              inputType="tel"
              shouldAutoFocus={carouselState === 1}
              inputStyle={classes.icOtpInput}
              renderInput={(propsOtp) => {
                return <input {...propsOtp} />;
              }}
            />
          </div>
          <div
            className={`${classes.icVerificationActionWrapper} ${classes.icResendWrapper}`}
          >
            <span>Didn’t get a SMS? </span>
            <a
              href="javascript:void(0)"
              onClick={(e) => {
                if (carouselState !== 1) {
                  return;
                }
                setOtp("");
                handleSendOtp(e, "Phone", true);
              }}
            >
              Resend SMS
            </a>
          </div>
        </> : (
          <div className={classes.icVerifyFailure}>
            <div className={classes.icIconWrapper}>
              <i
                className="fa fa-times-circle"
                style={{ fontSize: "50px", color: "red" }}
              />
            </div>
            <div className={classes.icDbicLoaderText}>
              {props.verifyOtpMessage?.info?.message}
            </div>
          </div>
        )}
        {(!isUserLockedOnVerify && !isUserDisabledOnVerify) ? <Button
          id="generateOtp"
          btnType="IcGenerateOTP"
          clicked={() => {
            if (carouselState !== 1) {
              return;
            }
            handleVerifyOtp();
          }}
          disabled={otp.length !== 6 || carouselState !== 1}
        >
          Verify now
        </Button> : <Button
          id="generateOtp"
          btnType="IcGenerateOTP"
          disabled={isUserDisabledOnVerify}
          clicked={(e) => {
            if (carouselState !== 1) {
              return;
            }
            setOtp("");
            handleSendOtp(e, "Phone", true);
          }}
        >
          Resend SMS
        </Button>}
        <div className={classes.icVerificationActionWrapper}>
          <Button
            id="tryCall"
            btnType="IcVerificationtryCall"
            disabled={isUserDisabledOnVerify}
            clicked={(e) => {
              if (carouselState !== 1) {
                return;
              }
              setOtp("");
              handleSendOtp(e, "Call", true);
            }}
          >
            Try phone call
          </Button>
          <Button
            id="startOver"
            btnType="IcVerificationStartOver"
            disabled={carouselState !== 1}
            clicked={() => {
              if (carouselState !== 1) {
                return;
              }
              handleStartOver();
            }}
          >
            Start over
          </Button>
        </div>
      </div>
    );
  };

  const renderDbicStateImage = () => {
    if (dbicState === "pending") {
      return <Spinner
        showTimer
        timerDuration={pollTime * 60}
        hideTimerText={true}
        onResetTimerReady={(resetFn) => {
          resetSpinnerTimer = resetFn;
        }}
      />;
    } else if (dbicState === "success") {
      return (
        <div className={classes.icIconWrapper}>
          <i
            className="fa fa-check-circle"
            style={{ fontSize: "50px", color: "green" }}
          />
        </div>
      );
    } else if (dbicState === "failure") {
      return (
        <div className={classes.icIconWrapper}>
          <i
            className="fa fa-times-circle"
            style={{ fontSize: "50px", color: "red" }}
          />
        </div>
      );
    } else {
      return null;
    }
  };

  const renderDbicStateMessage = () => {
    const daystamp = props.dbicData?.auditData?.timestamp ? moment(props.dbicData.auditData.timestamp).format("MMMM DD, YYYY") : null;
    const timestamp = props.dbicData?.auditData?.timestamp ? moment(props.dbicData.auditData.timestamp).format("HH:MM") : null;
    if (dbicState === "pending") {
      if (isDbicDoneBefore && props.reuseFlow) {
        return "Please wait. \n Validating your identity with the saved DBIC.";
      } else {
        return "Please wait for the user to complete verification. \n It may take up to a minute to process the results once the caller completes it on their phone.";
      }
    } else if (dbicState === "success") {
      return `Identity verification \nsuccessfully completed ${daystamp ? `\n at ${daystamp} ${timestamp ? ` at ${timestamp} UTC` : ""}` : ""}`;
    } else if (dbicState === "failure") {
      if (props.pollTimeout) {
        return `Identity verification timed out.`;
      }
      if (props.idverseResult) {
        return isSuperVisorOrSuperUser
          ? `Something went wrong. Please try again.`
          : `Something went wrong. \nPlease retry or escalate to HSID \nL1.5 support team for advanced verification.`;
      }
      return isSuperVisorOrSuperUser
        ? `Identity verification failed.${daystamp ? `\n at ${daystamp} ${timestamp ? ` at ${timestamp} UTC` : ""}` : ""}`
        : `Identity verification failed. ${daystamp ? `\n at ${daystamp} ${timestamp ? ` at ${timestamp} UTC` : ""}` : ""} \nPlease retry or escalate to HSID \nL1.5 support team for advanced verification.`;
    } else {
      return null;
    }
  };

  const getDbicContactValue = (flow, originalValue, essoValue) => {
    return flow === "resend" ? (originalValue || essoValue || "") : essoValue || "";
  };

  const renderDbicDeliveryForm = (flow) => {
    return (
      <>
        <label className={classes.icPhoneInputLabel}>Send by:</label>
        <div className={flow === "resend" ? classes.icResendLinkMethodContainer : classes.icLinkMethodContainer}>
          <div className={`${flow === "resend" ? classes.icResendLinkMethodOption : classes.icLinkMethodOption} ${linkMethod === "SMS" && classes.icLinkMethodOptionSelected}`}
            onClick={() => {
              if (carouselState === -1) {
                return;
              }
              setLinkMethod("SMS");
              setDbicFormError("");
              setEmail(getDbicContactValue(flow, originalDetails.email, props.essoData?.email?.value));
            }}>
            Text message
          </div>
          <hr className={classes.icLinkMethodSeparater} />
          <div className={`${flow === "resend" ? classes.icResendLinkMethodOption : classes.icLinkMethodOption} ${linkMethod === "EMAIL" && classes.icLinkMethodOptionSelected}`}
            onClick={() => {
              if (carouselState === -1) {
                return;
              }
              setLinkMethod("EMAIL");
              setDbicFormError("");
              setPhoneNumber(getDbicContactValue(flow, originalDetails.phoneNumber, phoneNumber || props.essoData?.phone?.number));
              setCountryCode(getDbicContactValue(flow, originalDetails.countryCode, countryCode || props.essoData?.phone?.countryCode));
            }}>
            Email
          </div>
        </div>
        {linkMethod === "SMS" ? (
          <>
            <label className={classes.icPhoneInputLabel}>Phone Number</label>
            <div className={classes.icPhoneInputWrapper}>
              <Input
                key={"inputPhoneCode"}
                elementType="inputPhoneCodeNew"
                elementConfig={{
                  type: "text",
                  id: "countryCode",
                  minLength: 1,
                  maxLength: 3,
                  pattern: "[0-9]{1,3}",
                  title: "Country Code can only contain numbers",
                  // wrapperStyles: {zIndex: "-1"},
                }}
                value={countryCode}
                invalid={false}
                shouldValidate={{
                  required: false,
                  minlength: 1,
                  maxlength: 3,
                }}
                touched={false}
                disabled={!(skipState === 2 && isSuperUser)}
                label={""}
                changed={(event) => {
                  if (carouselState !== 2) {
                    return;
                  }
                  if (
                    event.target.value.length > 0 &&
                    !/^\d+$/.test(event.target.value)
                  ) {
                    return;
                  }
                  dbicInputChangeHandler("countryCode", event.target.value);
                }}
                inputType={"icPhoneCode"}
                extendedInputClasses={classes.icExtendedInput}
                tabIndex={props.disableTab != undefined ? props.disableTab : 0}
              />
              <Input
                key={"phoneNumber"}
                elementType="input"
                elementConfig={{
                  type: "text",
                  id: "phone",
                  minLength: 7,
                  maxLength: 15,
                  pattern: "[0-9]{1,15}",
                  title: "Phone Numbers can only contain numbers",
                }}
                value={phoneNumber}
                invalid={false}
                shouldValidate={{
                  required: false,
                  minlength: 7,
                  maxlength: 15,
                }}
                touched={false}
                disabled={!(skipState === 2 && isSuperUser)}
                label={""}
                changed={(event) => {
                  if (carouselState !== 2) {
                    return;
                  }
                  if (
                    event.target.value.length > 0 &&
                    !/^\d+$/.test(event.target.value)
                  ) {
                    return;
                  }
                  dbicInputChangeHandler("phone", event.target.value);
                }}
                inputType={"icPhoneInput"}
                extendedInputClasses={classes.icExtendedInput}
                tabIndex={props.disableTab != undefined ? props.disableTab : 0}
              />
            </div>
          </>) :
          (<>
            <label className={classes.icPhoneInputLabel}>Email</label>
            <div className={classes.icPhoneInputWrapper}>
              <Input
                key={"email"}
                elementType="input"
                elementConfig={{
                  type: "text",
                  id: "email",
                  minLength: 5,
                  maxLength: 50,
                  // pattern: "[A-Za-z0-9._%+\-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$",
                  title: "Email should be valid",
                }}
                value={email}
                invalid={false}
                shouldValidate={{
                  required: false,
                  minlength: 5,
                  maxlength: 50,
                }}
                touched={false}
                disabled={false}
                label={""}
                changed={(event) => {
                  if (carouselState !== 2) {
                    return;
                  }
                  // if (
                  //   event.target.value.length > 0 &&
                  //   !/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(event.target.value)
                  // ) {
                  //   return;
                  // }
                  dbicInputChangeHandler("email", event.target.value, {
                    required: false,
                    minlength: 5,
                    maxlength: 50,
                    patternRegex: /^[A-Za-z0-9._%+\-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                    patternRegexMessage: "Invalid Email format",
                  });
                }}
                inputType={"icEmailInput"}
                extendedInputClasses={classes.icExtendedInput}
                tabIndex={props.disableTab != undefined ? props.disableTab : 0}
              />
            </div>
          </>)}
      </>
    )
  }

  const renderFailureSuccessScreenButtons = () => {
    if (props.idverseResult && dbicState === "failure") {
      return (
        <Button
          id="generateOtp"
          btnType="IcGenerateOTP"
          disabled={carouselState !== 2}
          clicked={() => {
            if (carouselState !== 2) {
              return;
            }
            handleTryAgain();
          }}
        >
          Try Again
        </Button>
      )
    }
    if (props.pollTimeout && dbicState === "failure") {
      return (
        <Button
          id="generateOtp"
          btnType="IcGenerateOTP"
          disabled={carouselState !== 2}
          clicked={() => {
            if (carouselState !== 2) {
              return;
            }
            resetDbicPollingWindow();
            props.startPolling();
          }}
        >
          Continue Verification
        </Button>
      )
    }

    return (
      <Button
        id="generateOtp"
        btnType="IcGenerateOTP"
        disabled={carouselState !== 2}
        clicked={() => {
          if (carouselState !== 2) {
            return;
          }
          props.resetDbicStatus();
        }}
      >
        Start new DBIC
      </Button>
    )
  }

  const renderDbicCard = () => {
    return (
      <div
        className={`${classes.icDbicWrapper} ${carouselState === 2 ? classes.icGenerateOtpWrapperActive : ""}`}
      >
        {carouselState !== 2 && <div className={classes.icOverlay}></div>}
        <h4 className={classes.CardEligibilityTitle}>
          {"Document-based identity confirmation (DBIC)"}
        </h4>
        {!showResendLinkModal ? dbicFormNotifier : null}
        {sendDbicLinkMessageNotifier}
        {reSendDbicLinkMessageNotifier}
        {expiredLinkMessageNotifier}
        {dbicState ? (
          <>
            <div className={classes.icDbicStateWrapper}>
              {renderDbicStateImage()}
              <div className={classes.icDbicLoaderText}>
                {renderDbicStateMessage()}
              </div>
            </div>

            {dbicState === "pending" ? (
              <>
                <div data-tip data-for="resendDbicMisuse">
                  <Button
                    id="generateOtp"
                    btnType="IcGenerateOTP"
                    disabled={carouselState !== 2 || isResendDbicLinkCoolingDown}
                    clicked={() => {
                      setOriginalDetails({
                        phoneNumber: phoneNumber,
                        countryCode: countryCode,
                        email: email,
                      });
                      setShowResendLinkModal(true);
                    }}
                  >
                    Resend Link
                  </Button>
                </div>
                {isResendDbicLinkCoolingDown && <ReactTooltip id="resendDbicMisuse" multiline className={classes.icTooltip}>
                  <span>Please wait 2 minutes after the last<br />
                    click before trying again.</span>
                </ReactTooltip>}
              </>) :
              renderFailureSuccessScreenButtons()}
            {!(isSuperVisorOrSuperUser || enableStepTwoTierOne) && (
              <Button
                id="generateOtp"
                btnType="IcGenerateOTPCall"
                disabled={carouselState !== 2}
                clicked={() => {
                  if (carouselState !== 2) {
                    return;
                  }
                  handleStartOver();
                }}
              // disabled={this.state.formError || !(this.props.essoData.phone?.number ||
              //       this.state.formDetails['phoneNumber'].value
              //     ) || !(this.props.essoData.phone?.countryCode || this.state.formDetails['countryCode'].value)
              //     || (this.props.userType===SESSION_TIER1USER && isAccountDisabled(this.props.essoData))
              //   }
              >
                Start over
              </Button>
            )}
          </>
        ) : (
          <>
            <div className={classes.icDbicInfoWrapper}>
              <a
                href="javascript:void(0)"
                onClick={() => {
                  if (carouselState !== 2) {
                    return;
                  }
                  handleWhatIsDbic();
                }}
              >
                What is DBIC
              </a>
            </div>
            <div>{IC_DBIC_DESC}</div>
            {renderDbicDeliveryForm()}
            <Button
              id="generateOtp"
              btnType="IcGenerateOTP"
              disabled={carouselState !== 2 || dbicFormError}
              clicked={() => {
                if (carouselState !== 2) {
                  return;
                }
                handleSendDbicLink();
              }}
            // disabled={this.state.formError || !(this.props.essoData.phone?.number ||
            //       this.state.formDetails['phoneNumber'].value
            //     ) || !(this.props.essoData.phone?.countryCode || this.state.formDetails['countryCode'].value)
            //     || (this.props.userType===SESSION_TIER1USER && isAccountDisabled(this.props.essoData))
            //   }
            >
              Send verification link
            </Button>
            {!(isSuperVisorOrSuperUser || enableStepTwoTierOne) && (
              <Button
                id="generateOtp"
                btnType="IcGenerateOTPCall"
                disabled={carouselState !== 2}
                clicked={() => {
                  if (carouselState !== 2) {
                    return;
                  }
                  handleStartOver();
                }}
              // disabled={this.state.formError || !(this.props.essoData.phone?.number ||
              //       this.state.formDetails['phoneNumber'].value
              //     ) || !(this.props.essoData.phone?.countryCode || this.state.formDetails['countryCode'].value)
              //     || (this.props.userType===SESSION_TIER1USER && isAccountDisabled(this.props.essoData))
              //   }
              >
                Start over
              </Button>
            )}
          </>
        )}
        {(isSuperVisorOrSuperUser || enableStepTwoTierOne) && (
          <>
            <div className={classes.icDbicAlternativeWrapper}>
              <hr className={classes.icHr} />
              <div className={classes.icOr2}>OR</div>
            </div>

            {!shouldHideTwoStepAttestation && (
              <Button
                id="generateOtp"
                btnType="IcGenerateOTP"
                disabled={carouselState !== 2}
                clicked={() => {
                  if (carouselState !== 2) {
                    return;
                  }
                  handle2StepRedirect();
                }}
              // disabled={this.state.formError || !(this.props.essoData.phone?.number ||
              //       this.state.formDetails['phoneNumber'].value
              //     ) || !(this.props.essoData.phone?.countryCode || this.state.formDetails['countryCode'].value)
              //     || (this.props.userType===SESSION_TIER1USER && isAccountDisabled(this.props.essoData))
              //   }
              >
                Start 2-step Authentication
              </Button>
            )}

            <Button
              id="generateOtp"
              btnType="IcGenerateOTPCall"
              disabled={carouselState !== 2}
              clicked={() => {
                if (carouselState !== 2) {
                  return;
                }
                handleStartOver();
              }}
            // disabled={this.state.formError || !(this.props.essoData.phone?.number ||
            //       this.state.formDetails['phoneNumber'].value
            //     ) || !(this.props.essoData.phone?.countryCode || this.state.formDetails['countryCode'].value)
            //     || (this.props.userType===SESSION_TIER1USER && isAccountDisabled(this.props.essoData))
            //   }
            >
              Start over
            </Button>
          </>
        )}
      </div>
    );
  };

  const render2StepCard = () => {
    return (
      <div
        className={`${classes.icGenerateOtpWrapper} ${carouselState === 3 ? classes.icGenerateOtpWrapperActive : ""}`}
      >
        {carouselState !== 3 && <div className={classes.icOverlay}></div>}
        <h4 className={classes.CardEligibilityTitle}>
          {"2-step Authentication"}
        </h4>
        {twoStepNotifier}
        <div>{IC_2STEP_DESC}</div>

        <Button
          id="generateOtp"
          btnType="IcGenerateOTP"
          disabled={carouselState !== 3 || twoStepMessage?.type}
          clicked={() => {
            if (carouselState !== 3) {
              return;
            }
            setShowTwoStepModal(true)
          }}
        // disabled={this.state.formError || !(this.props.essoData.phone?.number ||
        //       this.state.formDetails['phoneNumber'].value
        //     ) || !(this.props.essoData.phone?.countryCode || this.state.formDetails['countryCode'].value)
        //     || (this.props.userType===SESSION_TIER1USER && isAccountDisabled(this.props.essoData))
        //   }
        >
          2-step authentication passed
        </Button>
        <Button
          id="generateOtp"
          btnType="Ic2StepFail"
          disabled={carouselState !== 3 || twoStepMessage?.type}
          clicked={() => {
            if (carouselState !== 3) {
              return;
            }
            handleAttest(false);
          }}
        // disabled={this.state.formError || !(this.props.essoData.phone?.number ||
        //       this.state.formDetails['phoneNumber'].value
        //     ) || !(this.props.essoData.phone?.countryCode || this.state.formDetails['countryCode'].value)
        //     || (this.props.userType===SESSION_TIER1USER && isAccountDisabled(this.props.essoData))
        //   }
        >
          2-step authentication failed
        </Button>
      </div>
    );
  };

  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const {
      carouselState: { currentSlide },
    } = rest;
    return (
      <div className={classes.icCarouselButtonGroup}>
        {(isSuperVisorOrSuperUser || enableStepTwoTierOne) && !shouldHideTwoStepAttestation && <i
          className={`fa fa-chevron-left ${classes.icChevronLeft}`}
          onClick={() => goToSlide(0)}
        />}
        {[0, 1, 2, 3].map((val) => {
          return val === 3 && (!(isSuperVisorOrSuperUser || enableStepTwoTierOne) || shouldHideTwoStepAttestation) ? null : (
            <div
              key={val}
              className={`${classes.icCarouselDot} ${carouselState >= val ? classes.icCarouselDotActive : ""}`}
              onClick={() => goToSlide(val)}
            ></div>
          );
        })}
        {(isSuperVisorOrSuperUser || enableStepTwoTierOne) && !shouldHideTwoStepAttestation && <i
          className={`fa fa-chevron-right ${classes.icChevronRight}`}
          onClick={() => goToSlide((isSuperVisorOrSuperUser || enableStepTwoTierOne) ? 3 : 2)}
        />}
      </div>
    );
  };

  return (
    <Fragment>
      <div className={`${!(isSuperUser || enableStepTwoTierOne) ? classes.EilgibilityHeader : classes.EilgibilityHeaderSuperuser}`}>
        <h3 className={classes.EligibilityTitle}>{"Identity Confirmation"}</h3>
        {(isSuperUser || enableStepTwoTierOne) && <div className={classes.icSkipContainer}>
          <div
            className={`${classes.icSkipOption} ${skipState === 1 && classes.icSkipOptionSelected}`}
            onClick={(e) => {
              if (carouselState === -1 || skipState === 1) {
                return;
              }
              setSkipState(1)
              setCarouselState(0)
              setDbicFormError("");
              suppressDbicAutoAdvanceRef.current = false;
              if (skipState !== 1) {
                setCountryCode(props.essoData.phone?.countryCode || "")
                setPhoneNumber(props.essoData.phone?.number || "")
              }
              setEmail(props.essoData?.email?.value || "")
              setLinkMethod("SMS")
              carouselRef.current.goToSlide(0);
              props.resetDbicStatus();
            }}>
            <i
              className="fa fa-mobile"
              style={{
                fontSize: "20px",
                color: skipState === 1 ? "#fff" : "#000",
                cursor: "pointer",
                marginRight: "12px"
              }}
            />
            Phone-based
          </div>
          <hr className={classes.icSkipSeparater} />
          <div
            className={`${classes.icSkipOption} ${skipState === 2 && classes.icSkipOptionSelected}`}
            onClick={() => {
              if (carouselState === -1 || skipState === 2) {
                return;
              }
              setShowSkipModal(true);
            }}>
            <i
              className="fa fa-file-text-o"
              style={{
                fontSize: "15px",
                color: skipState === 2 ? "#fff" : "#000",
                cursor: "pointer",
                marginRight: "12px"
              }}
            />
            Document-based
          </div>
          {!shouldHideTwoStepAttestation &&
            <><hr className={classes.icSkipSeparater} />
              <div
                className={`${classes.icSkipOption} ${skipState === 3 && classes.icSkipOptionSelected}`}
                onClick={() => {
                  if (carouselState === -1 || skipState === 3) {
                    return;
                  }
                  setSkipState(3);
                  setCarouselState(3);
                  setDbicFormError("");
                  carouselRef.current.goToSlide(2);
                  props.resetDbicStatus();
                  props.resetOtpGeneratedMessage();
                  props.resetExpiredLinkMessage();
                  props.resetReSendDbicLinkMessage();
                  props.resetSendDbicLinkMessage();
                  setTwoStepMessage("");
                  setOtp("");
                  setCountryCode(props.essoData.phone?.countryCode || "")
                  setPhoneNumber(props.essoData.phone?.number || "")
                  setEmail(props.essoData?.email?.value || "")
                  setFirstName("")
                  setLastName("")
                  setDob("")
                  setLinkMethod("SMS")
                  setFormError("")
                  setIsPoaSelected(false)
                  suppressDbicAutoAdvanceRef.current = false;
                }}>
                <i
                  className="fa fa-question-circle-o"
                  style={{
                    fontSize: "15px",
                    color: skipState === 3 ? "#fff" : "#000",
                    cursor: "pointer",
                    marginRight: "12px"
                  }}
                />
                2-Step Authentication
              </div> </>}
        </div>}
      </div>
      {props.otpSpinnerProcessing ? (
        <Modal show={props.otpSpinnerProcessing}>
          <Spinner />
        </Modal>
      ) : null}
      <Modal show={showTwoStepModal} modalClosed={() => setShowTwoStepModal(false)}
        modalContainerClass={classes.attestModalContainerClass}>
        <div>
          <div className={classes.attestModalText}>
            I confirm that caller passed the 2-Step Process
          </div>
          <div className={classes.modalBtnContainer}>
            <Button id="attestsuccess" btnType="AttestDialogBtn" type="button"
              clicked={() => {
                setShowTwoStepModal(false)
              }}
            >No</Button>
            <Button id="attestsuccess" btnType="AttestDialogBtn" type="button"
              clicked={() => {
                if (carouselState !== 3) {
                  return;
                }
                handleAttest(true);
                setShowTwoStepModal(false)
              }}
            >Yes</Button>
          </div>
        </div>
      </Modal>
      {showResendLinkModal ? <Modal show={showResendLinkModal} modalClosed={() => setShowResendLinkModal(false)}
        modalContainerClass={classes.icSkipModalWrapper}>
        <div className={classes.icModalMain}>
          <div
            className={`${classes.icModalTitle} ${classes.icModalTitleBold}`}
          >
            <div className={classes.icSkipModalTitle}>Resend DBIC Link</div>
            <i
              className="fa fa-times"
              style={{
                fontSize: "20px",
                color: "rgb(0 0 0 / 68%)",
                cursor: "pointer",
              }}
              onClick={() => {
                setDbicFormError("");
                setCountryCode(originalDetails.countryCode || "")
                setPhoneNumber(originalDetails.phoneNumber || "")
                setEmail(originalDetails.email || "")
                setShowResendLinkModal(false);
              }}
            />
          </div>
          {showResendLinkModal && dbicFormNotifier}
          {renderDbicDeliveryForm("resend")}
          <div className={classes.icResendLinkModalBtnContainer}>
            <Button id="attestsuccess" btnType="skipIcCancelDialogBtn" type="button"
              clicked={() => {
                setDbicFormError("");
                setCountryCode(originalDetails.countryCode || "")
                setPhoneNumber(originalDetails.phoneNumber || "")
                setEmail(originalDetails.email || "")
                setShowResendLinkModal(false);
              }}
            >
              Cancel
            </Button>
            <Button id="attestsuccess" btnType="skipIcConfirmDialogBtn" type="button"
              disabled={dbicFormError}
              clicked={() => {
                if (carouselState !== 2 || isResendDbicLinkCoolingDown) {
                  return;
                }
                setShowResendLinkModal(false);
                setOriginalDetails({});
                handlereSendDbicLink()
              }}
            >
              Resend Link
            </Button>
          </div>
        </div>
      </Modal> : null}
      {showSkipModal ? <Modal show={showSkipModal} modalClosed={() => setShowSkipModal(false)}
        modalContainerClass={classes.icSkipModalWrapper}>
        <div className={classes.icModalMain}>
          <div
            className={`${classes.icModalTitle} ${classes.icModalTitleBold}`}
          >
            <div className={classes.icSkipModalTitle}>Warning</div>
            <i
              className="fa fa-times"
              style={{
                fontSize: "20px",
                color: "rgb(0 0 0 / 68%)",
                cursor: "pointer",
              }}
              onClick={() => {
                setShowSkipModal(false);
              }}
            />
          </div>
          <div className={classes.icSkipModalText}>
            If the OTP is not completed first, the previous Document Based Results cannot be used. The current link will
            also expire and won’t be valid if the account holder
            calls back later.
          </div>
          <div className={classes.icSkipModalBtnContainer}>
            <Button id="attestsuccess" btnType="skipIcCancelDialogBtn" type="button"
              clicked={() => {
                setShowSkipModal(false);
                setSkipState(1)
                if (skipState === 2 || skipState === 3) {
                  setCarouselState(0)
                  carouselRef.current.goToSlide(0);
                }
                if (skipState !== 1) {
                  setCountryCode(props.essoData.phone?.countryCode || "")
                  setPhoneNumber(props.essoData.phone?.number || "")
                }
                setEmail(props.essoData?.email?.value || "")
                setLinkMethod("SMS")
                setDbicFormError("");
                suppressDbicAutoAdvanceRef.current = false;
              }}
            >
              Complete OTP
            </Button>
            <Button id="attestsuccess" btnType="skipIcConfirmDialogBtn" type="button"
              clicked={() => {
                setShowSkipModal(false);
                setSkipState(2)
                setCarouselState(2)
                carouselRef.current.goToSlide(1);
                props.resetOtpGeneratedMessage();
                props.resetExpiredLinkMessage();
                props.resetReSendDbicLinkMessage();
                props.resetSendDbicLinkMessage();
                setTwoStepMessage("");
                setOtp("");

                //reset values in otp generation card
                setIsPoaSelected(false)
                setFirstName("")
                setLastName("")
                setDob("")
                if (skipState !== 2) {
                  setCountryCode(props.essoData.phone?.countryCode || "")
                  setPhoneNumber(props.essoData.phone?.number || "")
                  setEmail(props.essoData?.email?.value || "")
                  setLinkMethod("SMS")
                  setDbicFormError("");
                }
                suppressDbicAutoAdvanceRef.current = false;
                setFormError("")
                suppressDbicAutoAdvanceRef.current = false;
              }}
            >
              Continue to DBIC
            </Button>
          </div>
        </div>
      </Modal> : null}
      {showDbicInfo ? (
        <Modal
          show={showDbicInfo}
          modalClosed={() => setShowDbicInfo(false)}
          modalContainerClass={classes.icModalWrapper}
        >
          <div className={classes.icModalMain}>
            <div
              className={`${classes.icModalTitle} ${classes.icModalTitleBold}`}
            >
              <div>What is DBIC</div>
              <i
                className="fa fa-times"
                style={{
                  fontSize: "20px",
                  color: "#CFCFCF",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setShowDbicInfo(false);
                }}
              />
            </div>
            <div className={classes.icModalBold}>
              How will my information be used?
            </div>
            <div>
              Data collected by our partner, IDverse, will be used for
              authenticating/verifying your identity and detecting fraud. We
              will not share your data with third parties.
            </div>
            <div className={classes.icModalBold}>What data is collected?</div>
            <div>
              We will collect data from your ID document and your photo.
            </div>
            <div className={classes.icModalBold}>
              Why do I need to complete this?
            </div>
            <div>
              Identity verification is required to confirm your identity before
              we can proceed with the changes you requested to your account.
            </div>
          </div>
        </Modal>
      ) : null}
      <div className={`${classes.EligibilityWrapper} `}>
        {/* {!isOtpVerified ? null : (
          <div className={classes.EligibilityDisableLayer}></div>
        )} */}
        <div className={classes.identityConfirmationMainWrapper}>
          <Carousel
            swipeable
            draggable={false}
            // showDots
            responsive={{
              desktopLarge: {
                breakpoint: { max: 3000, min: 1440 },
                items: 3.12,
                slidesToSlide: 1, // optional, default to 1.
                partialVisibilityGutter: 12,
              },
              desktop: {
                breakpoint: { max: 1439, min: 1024 },
                items: 3.05,
                slidesToSlide: 1,
                partialVisibilityGutter: 12,
              },
              mobile: {
                breakpoint: { max: 1023, min: 965 },
                items: 1.7,
                slidesToSlide: 1, // optional, default to 1.
                partialVisibilityGutter: 20,
              },
              mobileSmall: {
                breakpoint: { max: 964, min: 0 },
                items: 1.2,
                slidesToSlide: 1, // optional, default to 1.
                partialVisibilityGutter: 20,
              },
            }}
            arrows={false}
            renderDotsOutside
            keyBoardControl={false}
            // centerMode
            partialVisible
            itemClass={classes.icItemWrapper}
            containerClass={classes.icWrapper}
            ref={carouselRef}
            customButtonGroup={<ButtonGroup />}
            renderButtonGroupOutside
          >
            {renderOptGenerationCard()}
            {renderVerificationCard()}
            {renderDbicCard()}
            {((isSuperVisorOrSuperUser || enableStepTwoTierOne) && !shouldHideTwoStepAttestation) && render2StepCard()}
          </Carousel>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    healthSafeId:
      state.member?.member?.healthSafeId ??
      state.member?.member?.essoData?.uuid,
    processing: state.member.processing,
    user: state.usr.user,
    member: state.member.member,
    essoData: state.member.member.essoData,
    verifyOtpMessage: state.identityConfirmation.verifyOtpMessage,
    verifyOtpTmxMessage: state.identityConfirmation.verifyOtpTmxMessage,
    generateOtpMessage: state.identityConfirmation.generateOtpMessage,
    tempGenerateOtpMessage: state.identityConfirmation.tempGenerateOtpMessage,
    genTokenResponse: state.identityConfirmation.genTokenResponse,
    otpSpinnerProcessing: state.identityConfirmation.otpSpinnerProcessing,
    isDbicDoneBefore: state.identityConfirmation.isDbicDoneBefore,
    sendDbicLinkMessage: state.identityConfirmation.sendDbicLinkMessage,
    reSendDbicLinkMessage: state.identityConfirmation.reSendDbicLinkMessage,
    expiredLinkMessage: state.identityConfirmation.expiredLinkMessage,
    idverseResult: state.identityConfirmation.idverseResult,
    dbicState: state.identityConfirmation.dbicState,
    dbicData: state.identityConfirmation.dbicData,
    enableAttest: state.identityConfirmation.enableAttest,
    reuseFlow: state.identityConfirmation.reuseFlow,
    pollTimeout: state.identityConfirmation.pollTimeout,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    modalSpinnerStart: () => dispatch(actions.modalSpinnerStart()),
    verifyEmailorPhone: (userData) =>
      dispatch(actions.verifyEmailorPhone(userData)),
    setMemPopUpDisplayMessage: (message) =>
      dispatch(actions.setMemPopUpDisplayMessage(message)),
    generateEmailOtpToken: (userData) =>
      dispatch(actions.generateEmailOtpToken(userData)),
    generateSmsOtpToken: (userData, otpType, origin, identityConfirmationFlow) =>
      dispatch(actions.generateSmsOtpTokenIc(userData, otpType, origin, identityConfirmationFlow)),
    verifySmsOtpToken: (userData, essoDetails, identityConfirmationFlow) =>
      dispatch(actions.verifySmsOtpTokenIc(userData, essoDetails, identityConfirmationFlow)),
    verifyEmailOtpToken: (userData) =>
      dispatch(actions.verifyEmailOtpToken(userData)),
    setOtpDisplayMessage: (message) =>
      dispatch(actions.setOtpDisplayMessage(message)),
    initiateAttest: (data, essoData, userType, identityConfirmationFlow) =>
      dispatch(actions.initiateAttestIc(data, essoData, userType, identityConfirmationFlow)),
    resetOtpGeneratedMessage: () =>
      dispatch(actions.resetOtpGeneratedMessage()),
    resetTempGenerateOtpMessage: () =>
      dispatch(actions.resetTempGenerateOtpMessage()),
    getDbicDetails: (userData, essoDetails, reuseFlow, poaData, identityConfirmationFlow) => dispatch(actions.getDbicDetailsIc(userData, essoDetails, reuseFlow, poaData, identityConfirmationFlow)),
    getIdverseResults: (userData, essoDetails, reuseFlow, poaData, identityConfirmationFlow) => dispatch(actions.getIdverseResultsIc(userData, essoDetails, reuseFlow, poaData, identityConfirmationFlow)),
    sendDbicLink: (userData, identityConfirmationFlow) => dispatch(actions.sendDbicLinkIc(userData, identityConfirmationFlow)),
    reSendDbicLink: (userData, identityConfirmationFlow) => dispatch(actions.reSendDbicLinkIc(userData, identityConfirmationFlow)),
    resetReSendDbicLinkMessage: () => dispatch(actions.resetReSendDbicLinkMessage()),
    resetSendDbicLinkMessage: () => dispatch(actions.resetSendDbicLinkMessage()),
    resetExpiredLinkMessage: () => dispatch(actions.resetExpiredLinkMessage()),
    pollDbic: (userData, essoDetails, reuseFlow, poaData, identityConfirmationFlow) =>
      dispatch(actions.pollDbic(userData, essoDetails, reuseFlow, poaData, identityConfirmationFlow)),
    dbicPollingFailure: (timeout) => dispatch(actions.dbicPollingFailure(null, timeout)),
    startPolling: () => dispatch(actions.startPolling()),
    resetDbicStatus: () => dispatch(actions.resetDbicStatus()),
    pushtoActivityLog: (userData, essoDetails, identityConfirmationFlow) => dispatch(actions.pushtoActivityLog(userData, essoDetails, identityConfirmationFlow)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(identityConfirmation);
